import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Placeholder from '../img/logo.svg'

export const ProductPageTemplate = ({
  title,
  price,
  description,
  image
}) => (
  <div className="content">
    <div
      className="full-width-image-container margin-top-0"
      style={{
        width: "800px",
        height: "800px",
        backgroundImage: image ? `url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })` : Placeholder,
      }}
    >
    </div>
    <div>
      <h1>{title}</h1>
      <h4>{price}</h4>
      <p>{description}</p>
    </div>
  </div>
)

ProductPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  price: PropTypes.number,
  description: PropTypes.string,
}

const ProductPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <ProductPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        price={frontmatter.price}
        description={frontmatter.description}
      />
    </Layout>
  )
}

ProductPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default ProductPage

export const productPageQuery = graphql`
  query ProductPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        price
        description
        image {
          childImageSharp {
              fluid(maxWidth: 120, quality: 100) {
              ...GatsbyImageSharpFluid
              }
          }
        }
      }
    }
  }
`
